import { render, staticRenderFns } from "./FormComponentIFRM.vue?vue&type=template&id=24727432"
import script from "./FormComponentIFRM.vue?vue&type=script&lang=js"
export * from "./FormComponentIFRM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports